import type { ChangeEvent } from "preact/compat";
import { forwardRef } from "preact/compat";

export type ComboboxSearchInputProps = {
  handleSearchChange?: (term: string) => void;
  handleSearchBlur?: (term: string) => void;
  term?: string;
};

export const ComboboxSearchInput = forwardRef<HTMLInputElement, ComboboxSearchInputProps>(({
  handleSearchChange,
  handleSearchBlur,
  term,
}, ref) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const term = event.currentTarget.value;
    handleSearchChange?.(term);
  };

  const handleBlur = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const term = target.value;
    // Only call blur handler if there's a value or if it's empty (to handle clearing)
    if (term !== undefined) {
      handleSearchBlur?.(term);
    }
  };

  return (
    <div className="my-4 px-1">
      <div className="relative mb-2 flex h-12 fs-unmask">
        <div
          className="absolute flex items-center top-2 left-2 justify-center text-center text-sm text-neutral-500 h-8 w-8"
          aria-hidden="true"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="-4 -3 32 32"
            strokeWidth="1"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
            />
          </svg>
        </div>

        <input
          ref={ref}
          className="appearance-none py-3 pl-12 text-base w-full rounded-md border-2 border-gt-lilac-dark bg-white"
          placeholder="Search"
          value={term}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </div>
    </div>
  );
});
